import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import SitesGridLayout from './containers/Grid';

export default function SiteLayout() {
  return <Router>
    <PrivateRoute path="/admin/sites" component={SitesGridLayout} />
  </Router>
}
